import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg';
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-[#C9963A] text-white hover:bg-[#D4A843] shadow-md hover:shadow-lg border border-transparent',
    secondary: 'bg-[#1B4332] text-white hover:bg-[#2D6A4F] shadow-md hover:shadow-lg border border-transparent',
    outline: 'bg-transparent border-2 border-[#1B4332] text-[#1B4332] hover:bg-[#1B4332]/5'
  };
  const sizes = {
    default: 'h-12 px-6 py-2 text-base',
    lg: 'h-14 px-8 py-4 text-lg'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9963A] disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-246">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';